import { graphql } from "@apollo/client/react/hoc"
import produce from "immer"
import compose from "lodash/flowRight"
import {
  PathItemFragmentDoc,
  ReorderPathItemsDocument
} from "../../api/generated"
import withPathQueryVariables from "./withPathQueryVariables"

export const getItemsFlaggedForReordering = (pathItems) => {
  // create a flat list of items that need to be updated
  let invalidPathItems = []
  function validatePathItem(pathItem, expectedOrder, expectedParentId) {
    if (
      pathItem.order != expectedOrder ||
      pathItem.parent_id != expectedParentId
    ) {
      invalidPathItems.push({
        id: pathItem.id,
        order: expectedOrder,
        parent_id: expectedParentId,
        source_id: pathItem.source_id
      })
    }
  }
  pathItems.forEach((pathItem, index) => {
    // Only validate the top-level item ordering if there are multiple,
    // ensuring a subset of a path can be reordered in isolation.
    if (pathItems.length > 1) {
      const expectedOrder = index + 1
      validatePathItem(pathItem, expectedOrder)
    }
    if (pathItem.items) {
      pathItem.items.forEach((childItem, index) => {
        const expectedOrder = index + 1
        const expectedParentId = pathItem.id
        validatePathItem(childItem, expectedOrder, expectedParentId)
      })
    }
  })

  return invalidPathItems
}

export default compose(
  withPathQueryVariables,
  graphql(ReorderPathItemsDocument, {
    options: (props) => ({
      onCompleted: () => {
        // update publish button - little ugly, but "ok" for now
        window.App &&
          window.App.getStore("path").storeTrigger("path:items:reordered")
      }
    }),
    props: ({ mutate }) => ({
      reorderPathItems: async (pathItems) => {
        const invalidPathItems = getItemsFlaggedForReordering(
          pathItems ? [...pathItems] : []
        )

        if (!invalidPathItems.length) return

        await mutate({
          variables: {
            path_id: pathItems[0].path_id,
            items: invalidPathItems
          },
          optimisticResponse: {
            __typename: "ReorderPathItemsMutation",
            reorderPathItems: true
          },
          update: (cache) => {
            // TODO: revert if server error
            invalidPathItems.forEach((pathItem) => {
              const fragment = {
                fragment: PathItemFragmentDoc,
                fragmentName: "PathItem",
                id: "PathItem:" + pathItem.id
              }
              // update path item
              const pathItemData = cache.readFragment(fragment)
              const nextPathItemData = produce(pathItemData, (draft) => {
                draft.order = pathItem.order
                draft.parent_id = pathItem.parent_id || null
              })
              cache.writeFragment({
                ...fragment,
                data: nextPathItemData
              })
            })
          }
        })
      }
    })
  })
)
